import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck } from "@phosphor-icons/react";

const BAND_STYLES = {
  Gold: { bg: "bg-yellow-100", text: "text-yellow-800", ring: "ring-yellow-300" },
  Silver: { bg: "bg-slate-200", text: "text-slate-800", ring: "ring-slate-300" },
  Bronze: { bg: "bg-amber-100", text: "text-amber-800", ring: "ring-amber-300" },
  New: { bg: "bg-blue-100", text: "text-blue-800", ring: "ring-blue-300" },
};

export default function TrustBadge({ staffId, compact = false }) {
  const [t, setT] = useState(null);
  useEffect(() => {
    if (!staffId) return;
    api.get(`/staff/${staffId}/trust`).then((r) => setT(r.data)).catch(() => setT(null));
  }, [staffId]);
  if (!t) return null;
  const s = BAND_STYLES[t.band] || BAND_STYLES.New;
  if (compact) {
    return (
      <span data-testid={`trust-badge-${staffId}`} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-bold ring-1 ${s.bg} ${s.text} ${s.ring}`}>
        <ShieldCheck size={12} weight="fill"/> {t.band} · {t.total}
      </span>
    );
  }
  return (
    <div data-testid={`trust-badge-${staffId}`} className={`card-tactile p-4 ${s.bg} ${s.ring} ring-1`}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <ShieldCheck size={20} weight="fill" className={s.text} />
          <span className={`font-display text-lg font-extrabold ${s.text}`}>{t.band}</span>
        </div>
        <span className={`font-display text-2xl font-extrabold ${s.text}`}>{t.total}<span className="text-sm opacity-60">/100</span></span>
      </div>
      <div className="space-y-1 text-xs text-slate-700">
        <Bar label="Reviews" v={t.components.reviews} max={40} />
        <Bar label="Reliability" v={t.components.reliability} max={25} />
        <Bar label="Verified skills" v={t.components.verified_skills} max={15} />
        <Bar label="Documents" v={t.components.documents} max={10} />
        <Bar label="Payouts" v={t.components.payouts} max={10} />
      </div>
    </div>
  );
}

function Bar({ label, v, max }) {
  const pct = Math.min(100, (v / max) * 100);
  return (
    <div>
      <div className="flex justify-between"><span>{label}</span><span className="font-semibold">{v}/{max}</span></div>
      <div className="h-1.5 bg-white/60 rounded-full overflow-hidden"><div className="h-full bg-slate-900/70" style={{ width: `${pct}%` }} /></div>
    </div>
  );
}
